import clsx from "clsx"

const ContainerSkeleton = ({custH, custW, custCls}) => {
  return <div className={clsx("animate-shimmer transition-opacity bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200", custH, custW, custCls)}></div>
}

export default ContainerSkeleton